import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { DownloadBlockNested, QuoteBlockNested } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import { dataLayerServices } from '../../../../seo/datalayer'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'

export type DownloadBlockNestedClassNames = Partial<{
  block: string
  inner: string
  content: string
  item: string
  itemTitle: string
  itemClickable: string
  itemIcon: string
}>

export const downloadBlockNestedClasses: DownloadBlockNestedClassNames = {
  block: 'block--nested block--download-nested block--download',
  inner: 'block__inner',
  content: 'block__content',
  itemClickable: 'button button--tertiary block--download-nested--button',
  itemTitle: 'block--download-nested--title',
  itemIcon: 'list__icon block--download-nested--icon',
}

export const DownloadBlockNestedLayout = (props: DownloadBlockNested) => {
  const { index, item, title, intro } = props
  return (
    <div key={index} className={getClassNameModern(downloadBlockNestedClasses, 'block', '')}>
      <div className={getClassNameModern(downloadBlockNestedClasses, 'inner', '')}>
        {item.fileUrl && (
          <a
            onClick={() => dataLayerServices.downloadDataLayer('download', item.fileName)}
            id={`download-item-${index}`}
            download={true}
            target="_blank"
            rel="noopener noreferrer"
            href={item.fileUrl}
            className={getClassNameModern(
              downloadBlockNestedClasses,
              'itemClickable',
              'd-flex align-items-baseline py-2 text-decoration-none'
            )}
          >
            <SharedBlockLayout.SVGIcon
              iconId="#icon--download"
              width="24px"
              height="24px"
              className={getClassNameModern(downloadBlockNestedClasses, 'itemIcon', 'me-3')}
            />

            <div>
              {(title || item.fileName) && (
                <p className={getClassNameModern(downloadBlockNestedClasses, 'itemTitle', 'me-3')}>
                  {title || item.fileName}
                </p>
              )}
              {intro && <p>{intro}</p>}
            </div>
          </a>
        )}
      </div>
    </div>
  )
}
